import {BaseService} from "./base.service";

class SupplierInstitutionsService extends BaseService {

    constructor() {
        super('api/institutions')
    }
}

export const supplierinstitutionsService = new SupplierInstitutionsService();
